import { Validator } from '@vista-digital/validator';
import { defaultOrderPaymentFormAssets, orderPaymentFormAssetsValidator } from './assets';
import { defaultOrderPaymentFormCdnOptions, orderPaymentFormCdnOptionsValidator } from './cdn-options';
import { defaultOrderPaymentFormConfig, orderPaymentFormConfigValidator } from './config';
import { defaultOrderPaymentFormDisplayText, orderPaymentFormDisplayTextValidator } from './display-text';
import { orderPaymentFormEventsValidator } from './events';
export const OrderPaymentFormPropsValidator = Validator.object({
    displayText: orderPaymentFormDisplayTextValidator,
    assets: orderPaymentFormAssetsValidator,
    events: orderPaymentFormEventsValidator,
    config: orderPaymentFormConfigValidator,
    cdnOptions: orderPaymentFormCdnOptionsValidator
});
export const defaultOrderPaymentFormProps = {
    displayText: defaultOrderPaymentFormDisplayText,
    assets: defaultOrderPaymentFormAssets,
    config: defaultOrderPaymentFormConfig,
    events: {},
    cdnOptions: defaultOrderPaymentFormCdnOptions
};
